document.addEventListener('DOMContentLoaded', function () {

  /* ---------- 1. Rotating placeholder (real input placeholder now) ---------- */
  var terms = [
    { word: 'Hair Care',    emoji: '💇' },
    { word: 'Skin Care',    emoji: '🧴' },
    { word: 'Fragrances',   emoji: '🌸' },
    { word: 'New Arrivals', emoji: '✨' }
  ];
  var placeholderInputs = document.querySelectorAll('[data-search-rotate-placeholder]');
  function setPlaceholder(idx) {
    var t = terms[idx];
    placeholderInputs.forEach(function (el) {
      el.placeholder = 'Search for ' + t.word + ' ' + t.emoji;
    });
  }
  if (placeholderInputs.length) {
    var pIndex = 0;
    setPlaceholder(pIndex);
    setInterval(function () {
      pIndex = (pIndex + 1) % terms.length;
      setPlaceholder(pIndex);
    }, 2500);
  }

  /* ---------- 2. Live predictive search (Shopify's own suggest.json API) ---------- */
  var searchBars = document.querySelectorAll('.mobile-search-bar');

  searchBars.forEach(function (bar) {
    var input   = bar.querySelector('.mobile-search-bar__input');
    var results = bar.querySelector('[data-search-results]');
    if (!input || !results) return;

    var debounceTimer;

    function renderResults(queries, products) {
      var html = '';

      if (queries && queries.length) {
        html += '<div class="mobile-search-bar__section-label">Suggestions</div>';
        html += queries.map(function (q) {
          return '<a class="mobile-search-bar__suggestion" href="/search?q=' + encodeURIComponent(q.text) + '">' + q.styled_text + '</a>';
        }).join('');
      }

      if (products && products.length) {
        html += '<div class="mobile-search-bar__section-label">Products</div>';
        html += products.map(function (p) {
          var img = p.image ? '<img src="' + p.image + '" alt="" loading="lazy">' : '';
          return (
            '<a class="mobile-search-bar__result" href="' + p.url + '">' +
              '<span class="mobile-search-bar__result-thumb">' + img + '</span>' +
              '<span class="mobile-search-bar__result-info">' +
                '<span class="mobile-search-bar__result-title">' + p.title + '</span>' +
                '<span class="mobile-search-bar__result-price">' + p.price + '</span>' +
              '</span>' +
            '</a>'
          );
        }).join('');
      }

      if (!html) {
        html = '<div class="mobile-search-bar__empty">No results found</div>';
      }

      results.innerHTML = html;
      results.hidden = false;
    }

    function fetchResults(query) {
      if (!query) {
        results.hidden = true;
        results.innerHTML = '';
        return;
      }
      results.innerHTML = '<div class="mobile-search-bar__empty">Searching…</div>';
      results.hidden = false;
      fetch('/search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product,query&resources[limit]=6&resources[options][fields]=title,product_type,variants.title')
        .then(function (res) {
          if (!res.ok) throw new Error('Search request failed (status ' + res.status + ')');
          return res.json();
        })
        .then(function (data) {
          var r = (data.resources && data.resources.results) || {};
          renderResults(r.queries || [], r.products || []);
        })
        .catch(function (err) {
          results.innerHTML = '<div class="mobile-search-bar__empty">Search error: ' + err.message + '</div>';
          results.hidden = false;
        });
    }

    input.addEventListener('input', function () {
      clearTimeout(debounceTimer);
      var query = input.value.trim();
      debounceTimer = setTimeout(function () { fetchResults(query); }, 300);
    });

    input.addEventListener('focus', function () {
      if (input.value.trim()) fetchResults(input.value.trim());
    });

    // Escape key closes the dropdown and un-focuses the field
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' || e.key === 'Esc') {
        results.hidden = true;
        results.innerHTML = '';
        input.blur();
      }
    });

    // close results when tapping/clicking anywhere outside this bar
    document.addEventListener('click', function (e) {
      if (!bar.contains(e.target)) {
        results.hidden = true;
      }
    });
    document.addEventListener('touchstart', function (e) {
      if (!bar.contains(e.target)) {
        results.hidden = true;
      }
    }, { passive: true });
  });

  /* ---------- 3. Voice search (Web Speech API) ---------- */
  var SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
  var micButtons = document.querySelectorAll('[data-voice-search]');

  micButtons.forEach(function (btn) {
    if (!SpeechRecognition) {
      btn.style.display = 'none'; // e.g. most iOS Safari versions
      return;
    }

    btn.addEventListener('click', function (e) {
      e.preventDefault();
      var bar = btn.closest('.mobile-search-bar');
      var input = bar ? bar.querySelector('.mobile-search-bar__input') : null;

      btn.classList.add('listening');
      var recognition = new SpeechRecognition();
      recognition.lang = 'en-US';
      recognition.interimResults = false;
      recognition.maxAlternatives = 1;

      recognition.onresult = function (event) {
        var transcript = event.results[0][0].transcript;
        if (input) {
          input.value = transcript;
          input.focus();
          input.dispatchEvent(new Event('input', { bubbles: true }));
        }
      };
      recognition.onend = function () { btn.classList.remove('listening'); };
      recognition.onerror = function () { btn.classList.remove('listening'); };

      try {
        recognition.start();
      } catch (err) {
        btn.classList.remove('listening');
      }
    });
  });

});